'use es6';

export const APPLE_EMAIL_PRIVACY_URL = 'https://community.hubspot.com/t5/HubSpot-Community-Blog/How-to-Prepare-for-the-Apple-s-iOS15-Privacy-Changes-Checklist/ba-p/494069';